import { useEffect, useState } from "react";
import React from 'react';
import { Link } from 'react-router-dom'
import { BaseUrl } from "../../../helper/BaseUrl";

export default function ComparisonListingCards({ data }) {
  const [visibleCount, setVisibleCount] = useState(6);
  useEffect(() => {
    setVisibleCount(6);
  }, [data]);

  const handleLoadMore = () => {
    if (visibleCount >= data.length) {
      setVisibleCount(6);
    } else {
      setVisibleCount((prev) => Math.min(prev + 3, data.length));
    }
  };


  return (
    <>
      <section className="ComparisonListingCards">
        <div className="container">
          <div className="row">
            {data.slice(0, visibleCount).map((item, index) => (
              <div className="col-lg-4 col-md-6" key={index}>
                <div className="ComparisonListingCard-box">
                  <Link to={`/comparison/${item?.slug}`} >
                    <img src={`${BaseUrl}${item?.listing_image}`} className="img-responsive" alt={item?.title} loading="lazy" />
                    <span>{item?.title}</span>
                    <p>{item?.listing_description}</p>
                    <label className="read-more"> See The Comparison{" "}  <i className="fa-solid fa-arrow-right"></i>  </label>
                  </Link>
                </div>
              </div>
            ))}
          </div>
          {data.length > 6 && (
            <div className="load-more text-center">
              <button className="theme-btn" onClick={handleLoadMore}  >
                <span>  {visibleCount >= data.length ? "Load Less" : "Load more"}  </span>
              </button>
            </div>
          )}
        </div>
      </section>
    </>
  )
}
